import { DOMAIN_THEME_MAP, SiteEnum } from "@/constants";

//获取html页面中script 标签 id 为ai-agent的标签
export const getAgentFromScript = (): string => {
  let agent = "";
  // 通过id获取script标签
  const scriptElement = document.getElementById(
    "ai-agent",
  ) as HTMLScriptElement | null;
  if (scriptElement) {
    try {
      // 解析查询参数
      const src = scriptElement.src;
      const url = new URL(src);
      agent = url.searchParams.get("agent") || "";
    } catch (error) {
      console.error("Error parsing query parameters:", error);
    }
  }
  //本地环境，使用默认的agent
  if (!agent && /^(localhost|127\.0\.0\.1)/.test(window.location.hostname)) {
    agent = "JVkB26VW2XKwVnfa0luNNUAeBbCdAfHbjTNdaXfDLSEMTJtR";
  }
  return agent;
};

//获取站点主题
const themeCache: any = {}; // 缓存结果以提高性能
export const getSiteTheme = (host: string) => {
  if (!host) return SiteEnum.NXZ; // 默认值
  // 检查缓存
  if (themeCache[host]) {
    return themeCache[host];
  }
  // 查找匹配的域名
  const domainKey = Object.keys(DOMAIN_THEME_MAP).find((key) =>
    host.includes(key),
  );
  // 获取主题或使用默认值
  const theme = domainKey ? DOMAIN_THEME_MAP[domainKey] : SiteEnum.NXZ;
  // 缓存结果
  themeCache[host] = theme;
  return theme;
};

//获取当前主域名
export const getTargetUrl = () => {
  let hostName = window.location.hostname;
  // console.log(process.env.REACT_APP_BASE_URL, "process.env.REACT_APP_BASE_URL");
  const isLocalDev =
    process.env.NODE_ENV === "development" &&
    /^(localhost|127\.0\.0\.1)$/.test(hostName);
  if (isLocalDev) {
    return "";
  }

  // 检测是否为测试环境
  const isTestEnv =
    hostName.includes("test") ||
    hostName === "localhost" ||
    hostName === "127.0.0.1" ||
    hostName === "192.168.60.255";
  if (isTestEnv) {
    return "https://ai-agent-test-api.afirstsoft.cn";
  }

  //如果是预发布环境域名/正式环境域名，临时聊天页面不需要根据页面域名去获取接口域名
  if (
    hostName === "ai-agent-stage.afs-api.com" ||
    hostName === "ai-agent.afs-api.com"
  ) {
    return process.env.REACT_APP_BASE_URL || "";
  }

  // 提取主域名
  let domainParts = hostName.split(".");
  const isSubdomain = domainParts.length > 2;

  // 处理特殊后缀
  const specialTlds = ["com", "cn", "net"];
  const hasSpecialTld =
    isSubdomain && specialTlds.includes(domainParts[domainParts.length - 2]);

  // 计算主域名起始位置
  const startIndex = Math.max(0, domainParts.length - (hasSpecialTld ? 3 : 2));
  const mainDomain = domainParts.slice(startIndex).join(".");
  // 处理带端口号的情况
  const port = window.location.port ? `:${window.location.port}` : "";
  // console.log(`https://aics.${mainDomain}${port}`, "接口域名链接");
  return `https://aics.${mainDomain}${port}`;
};

// url链接地址下载
export const downloadFile = (url: string, name: string) => {
  const blob = new Blob([url]);
  const downloadElement = document.createElement("a");
  const href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  downloadElement.download = name;
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
  window.URL.revokeObjectURL(href);
};

//滚动到底部的函数
export const scrollDistanceFun = (dialogueContentRef: any) => {
  const dialogueContentEle = dialogueContentRef?.current;
  const contentEle = document.querySelector(
    "[data-scroll-container]",
  ) as HTMLElement;
  if (contentEle && dialogueContentEle) {
    const height = dialogueContentEle.scrollHeight + 84;
    contentEle.scrollTo({
      top: height,
      left: 0,
      behavior: "smooth",
    });
  }
};

/**
 * 处理文件响应数据
 * @param file 当前文件
 * @returns
 */
export const formatFiles = (file: any) => {
  if (file?.response) {
    const { uid, body } = file.response;
    return {
      uid,
      status: file.status,
      ...body,
      url: body?.path,
      type: 0,
    };
  }
  return null;
};

// 生成消息唯一ID
export const generateUuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * 设置动态品牌主色
 * @param brandColor 品牌主色值，例如 #FF5500
 */
export const applyBrandColor = (brandColor?: string) => {
  if (!brandColor) return;

  const root = document.documentElement;
  const aiCustomerService = document.getElementById("ai-customer-service");

  // 设置品牌主色CSS变量
  root.style.setProperty("--brand-primary-color", brandColor);
  aiCustomerService?.style.setProperty("--brand-primary-color", brandColor);
};
